export default "__VITE_ASSET__DQNNU2wa__"